import tracking from 'dibs-tracking';
import { getPromoCreative } from '../../helpers/getPromoCreative';
import {
    ATTRS_L1_CREATOR,
    ATTRS_ATTRIBUTE,
    DATA_GA_ID_KEY,
    DATA_GA_NAME_KEY,
} from '../gaConstants';

function trackShopByItemsImpressions(items) {
    tracking.trackEcommerce({
        type: 'promotionImpression',
        promotions: items.map((item, index) => {
            const position = index + 1;
            const attr = index < 4 ? ATTRS_L1_CREATOR : ATTRS_ATTRIBUTE;

            return {
                id: `shop-by-${attr[DATA_GA_ID_KEY]}`,
                name: `Shop by ${attr[DATA_GA_NAME_KEY]}`,
                creative: getPromoCreative(item.link),
                position: position,
            };
        }),
    });
}

function trackShopByItemClick(item, index) {
    const position = index + 1;
    const attr = index < 4 ? ATTRS_L1_CREATOR : ATTRS_ATTRIBUTE;

    tracking.trackEcommerce({
        type: 'promoClick',
        promotions: [
            {
                id: `shop-by-${attr[DATA_GA_ID_KEY]}`,
                name: `Shop by ${attr[DATA_GA_NAME_KEY]}`,
                creative: getPromoCreative(item.link),
                position: position,
            },
        ],
    });
}

function trackShopByLocationsImpressions() {
    tracking.trackEcommerce({
        type: 'promotionImpression',
        promotions: [
            {
                id: 'shop-by-location',
                name: 'Shop by Location',
                creative: 'none',
                position: 1,
            },
        ],
    });
}

function trackShopByLocationClick(item, index) {
    const position = index + 1;
    tracking.trackEcommerce({
        type: 'promoClick',
        promotions: [
            {
                id: 'shop-by-location',
                name: 'Shop by Location',
                creative: getPromoCreative(item.link),
                position: position,
            },
        ],
    });
}

export {
    trackShopByItemsImpressions,
    trackShopByLocationsImpressions,
    trackShopByItemClick,
    trackShopByLocationClick,
};
